/**
 * GraphQL queries and hooks — audit pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { AuditEventFilter, AuditEventsPage } from '../types/audit';

export const AUDIT_EVENT_FIELDS = gql`
  fragment AuditEventFields on AuditEvent {
    eventId
    eventType
    timestamp
    actor {
      type
      id
      name
      email
    }
    resource {
      type
      id
      name
    }
    action
    actionDetails
    context {
      requestId
      source
    }
    result
    errorCode
    errorMessage
  }
`;

export const GET_AUDIT_EVENTS = gql`
  ${AUDIT_EVENT_FIELDS}
  query GetAuditEvents($filter: AuditEventFilter!, $limit: Int, $cursor: String) {
    auditEvents(filter: $filter, limit: $limit, cursor: $cursor) {
      items {
        ...AuditEventFields
      }
      nextCursor
      count
      totalCount
      isScoped
    }
  }
`;

export function useAuditEvents(
  filter: AuditEventFilter,
  limit: number = 50,
  cursor?: string
): QueryResult<{ auditEvents: AuditEventsPage }> {
  return useQuery(GET_AUDIT_EVENTS, {
    variables: { filter, limit, cursor },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
}
